import MerchantEvaluationJudgeApi from '@/api/merchant-evaluation-judge'

/**
 * 评审系统 - 评审方案管理
 */

const state = {
}

const mutations = {
}

const actions = {
  async list ({ commit }, params) {
    const result = await MerchantEvaluationJudgeApi.list(params)
    return result
  },
  async getById ({ commit }, id) {
    const result = await MerchantEvaluationJudgeApi.getById(id)
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantEvaluationJudgeApi.insert(data)
    return result
  },
  async batchAdd ({ commit }, data) {
    const result = await MerchantEvaluationJudgeApi.batchAdd(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantEvaluationJudgeApi.update(data)
    return result
  },
  async uploadJudge ({ commit }, forms) {
    const result = await MerchantEvaluationJudgeApi.uploadJudge(forms)
    return result
  },
  async remove ({ commit }, id) {
    const result = await MerchantEvaluationJudgeApi.remove(id)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-judge.js